import React from 'react'
import Select from 'react-select'
import { OptionTypeBase, ValueType } from 'react-select/src/types'

interface IinputProp {
  label: string
  defaultValue: any
  styles?: any
  className?: string
  placeholder: string
  options: OptionTypeBase[]
  noDefault?: boolean
  noOptionsMessage?: ({inputValue}: any) => string | null
  onChange?: (option: ValueType<OptionTypeBase>) => void
  onSelect?: (option: ValueType<OptionTypeBase>) => void
  onInputChange?: (value: string) => void
  value?: any,
  disabled?: boolean
}

interface IinputState {
  inputValue: string
}

const defaultNoOption = ({value}: any) => 'No Options'
class LabeledSelectField extends React.Component<IinputProp, IinputState> {
  constructor(props: IinputProp) {
    super(props)

    this.state = {
      inputValue: ''
    }
  }
  onInputChange = (value: string) => {
    if (this.state.inputValue !== value) {
      if (this.props.onInputChange) {
        this.props.onInputChange(value)
      }
    }
    this.setState({
      inputValue: value
    })
  }

  render() {
    const { label = '', options = [], styles, placeholder, value, disabled} = this.props
    return (
      <Select
        value={value ? value : this.props.noDefault ? null : options[0]}
        onChange={(selectedValue: ValueType<OptionTypeBase>) => {
          this.props.onChange && this.props.onChange(selectedValue)
          this.props.onSelect && this.props.onSelect(selectedValue)
        }}
        onInputChange={this.onInputChange}
        label={label}
        options={options}
        styles={styles}
        placeholder={placeholder}
        className={this.props.className}
        isDisabled={disabled}
        noOptionsMessage={this.props.noOptionsMessage || defaultNoOption}
      />
    )
  }
}

export default LabeledSelectField
